import TicketTrendsChart from './TicketTrendsChart';
import PerformanceMetrics from './PerformanceMetrics';
import LevelWisePerformance from './LevelWisePerformance';

export default function DashboardView({
    datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date,
  setdates,
  setranges,
  setSelectedRange
}) {
  return (
 <div className="dashboard-layout">
  <div className="dashboard-row">
    <div className="left-panel">
      <TicketTrendsChart 
        datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
    date={date}
    setdates={setdates}

      setranges={setranges}
  setSelectedRange={setSelectedRange}


      
      />
    </div>
    <div className="right-panel">
      <PerformanceMetrics range={range} 
      
        datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
  date={date}
      />
      <LevelWisePerformance 
          datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
range={range} 
  date={date}
  setdates={setdates}

  
      />
    </div>
  </div>
</div>

  );
}
